export class ViewCase {
    ApprovalDate?: any;
    IsInterim: boolean;
    InterimDate?: any;
    HoldAuthorizationTC?: any;
    CaseID: number;
    Context: string;
    DepartmentContext: string;
    Status: string;
    ForRoleTC: string;
    AuthorizationReason?: any;
    InputDate: Date;
    ActivityTC: string;
    AssignedControllerUserID?: any;
    DepartmentDivisionID: string;
    MessageID?: any;
    MessageTypeTC?: any;
    LastName?: any;
    MessageTextTypeTC?: any;
    MessageCreationDate?: any;
    LastMessageReportDate?: any;
    MessageExtendedID?: any;
    ExtMsgLastName?: any;
    ExtMessageStatusTC?: any;
    MessageDate?: any;
    VisitTime: string;
    VisitDate: Date;
    Assigner: string;
    AssignedExpertUserID: number;
    LicensePlate?: any;
    BrandTC?: any;
    DIB: number;
    VisitPersonTypeTC: string;
    VisitPostalCode: string;
    VisitCity: string;
    VisitName: string;
    DocumentCount: number;
    PhotoCount: number;
    NewDocumentsCount: number;
    NewPhotosCount: number;
    FirstActionDueDate?: any;
    FirstActionColourCodeBackGround?: any;
    ActionsCount: number;
    IntroductionSubreportBE?: any;
    TotalLossCaseBE?: any;
    TextSubreportBE?: any;
    NormcalculationBE?: any;
    UniSubreportBE?: any;
    TotalLossSubReportBE?: any;
    DevaluationSubReportBE?: any;
    LockedByUserName?: any;
    LockedByUserID?: any;
    InsuredName: string;
    Authorizer?: any;
    AuthorizerID?: any;
    InThreatmentBy?: any;
    InThreatmentByID?: any;
    AE?: any;
    ExpertName: string;
    ReporterName: string;
    FrontPageBlockSubreportBE?: any;
    ObjectTC?: any;

    public constructor(init?: Partial<ViewCase>) {
        Object.assign(this, init);
    }
}
